<script setup>
import { cn } from "@/lib/utils.js";

const props = defineProps({
  class: { type: String, required: false },
});
</script>

<template>
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :class="cn('fill-current text-brand-blue', props.class)"
  >
    <path
      d="M20.2452 22.1975L11.5002 13.4387L2.75523 22.1975L0.802734 20.245L9.56149 11.5L0.802734 2.755L2.75523 0.802498L11.5002 9.56125L20.2452 0.816248L22.184 2.755L13.439 11.5L22.184 20.245L20.2452 22.1975Z"
    />
  </svg>
</template>

<style scoped></style>
